import axios from 'axios'
import store from '../../store/index'

const state = {
}

const mutations = {
}

const actions = {
  carDetection ({ commit }, detection) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/makeAndPlate',
        data: detection,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
